import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#800000',
    },
    secondary: {
      main: '#5c5c5c',
    },
    gold: {
      main: '#b68d2c',
    },
  },
});

export default theme;
